import React, { useEffect, useState } from "react";
import Preheader from "./Preheader";
import Headerads from "./Headerads";
import Header from "./Header";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./HomeCategory.css";
import Prefooterads from "../Homecomponents/Prefooterads";
import Newsletter from "../Homecomponents/Newsletter";
import Footer from "../Homecomponents/Footer";
import SocialLinks from "../Homecomponents/Sociallinks";
import Endfooter from "../Homecomponents/Endfooter";
import { cartUtils, wishlistUtils } from "../utils/userCartWishlistUtils";
import ProgressLoader from "../Loader/ProgressLoader";
import Superheader from "./Superheader";
import { FaHeart, FaRegHeart } from "react-icons/fa";

const Kalmainhome = () => {
  const [isSticky, setIsSticky] = useState(false);
  const [subCategories, setSubCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showLoginAlert, setShowLoginAlert] = useState(false);
  const [cartCounts, setCartCounts] = useState({});
  const [wishlistStatus, setWishlistStatus] = useState({});
  const navigate = useNavigate();

  // Sticky header effect
  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Initialize cart and wishlist status
  useEffect(() => {
    if (products.length > 0) {
      const initialCartCounts = {};
      const initialWishlistStatus = {};

      products.forEach((product) => {
        const cart = cartUtils.getCart();
        initialCartCounts[product.id] = cart[product.id] || 0;
        initialWishlistStatus[product.id] = wishlistUtils.isInWishlist(
          product.id
        );
      });

      setCartCounts(initialCartCounts);
      setWishlistStatus(initialWishlistStatus);
    }
  }, [products]);

  // Fetch data for home category (ID: 1)
  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch subcategories for home category
        const subCatResponse = await axios.get(
          "https://api.dremerz.net/api/DZ_8925_KalanjiyamEcom_Products_SubCategory_SubCategoryList"
        );
        setSubCategories(subCatResponse.data?.reverse());

        // Fetch products for home category
        const productsResponse = await axios.get(
          "https://api.dremerz.net/api/DZ_8925_KalanjiyamEcom_Products_AllProducts_ProductsList"
        );
        setProducts(productsResponse.data?.reverse());

        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Cart handlers
  const handleAddToCart = async (product) => {
    const success = await cartUtils.addToCart(product.id, 1);
    if (success) {
      setCartCounts((prev) => ({
        ...prev,
        [product.id]: (prev[product.id] || 0) + 1,
      }));
    } else {
      setShowLoginAlert(true);
    }
  };

  const handleRemoveFromCart = async (productId) => {
    const success = await cartUtils.removeFromCart(productId);
    if (success) {
      setCartCounts((prev) => ({
        ...prev,
        [productId]: 0,
      }));
    }
  };

  const handleIncreaseQuantity = async (productId) => {
    const success = await cartUtils.addToCart(productId, 1);
    if (success) {
      setCartCounts((prev) => ({
        ...prev,
        [productId]: (prev[productId] || 0) + 1,
      }));
    }
  };

  const handleDecreaseQuantity = async (productId) => {
    if (cartCounts[productId] > 1) {
      const success = await cartUtils.updateQuantity(
        productId,
        cartCounts[productId] - 1
      );
      if (success) {
        setCartCounts((prev) => ({
          ...prev,
          [productId]: prev[productId] - 1,
        }));
      }
    } else {
      await handleRemoveFromCart(productId);
    }
  };

  // Wishlist handlers
  const handleWishlistToggle = async (productId) => {
    if (wishlistStatus[productId]) {
      const success = await wishlistUtils.removeFromWishlist(productId);
      if (success) {
        setWishlistStatus((prev) => ({
          ...prev,
          [productId]: false,
        }));
      }
    } else {
      const success = await wishlistUtils.addToWishlist(productId);
      if (success) {
        setWishlistStatus((prev) => ({
          ...prev,
          [productId]: true,
        }));
      } else {
        setShowLoginAlert(true);
      }
    }
  };

  const handleProductClick = (product) => {
    navigate(`/product/${product.id}`, { state: { product } });
  };

  // Handle See All click
  const handleSeeAllClick = (subCategoryId, subCategoryName) => {
    navigate(`/seeall/${subCategoryId}`, {
      state: {
        subCategoryName,
        categoryId: 1, // Home category
      },
    });
  };

  // Group products by subcategory
  const productsBySubCategory = subCategories.reduce((acc, subCategory) => {
    const subCategoryProducts = products.filter(
      (product) => product.subCategoryId === subCategory.id
    );
    if (subCategoryProducts.length > 0) {
      acc[subCategory.id] = {
        name: subCategory.subCategoryName,
        products: subCategoryProducts,
      };
    }
    return acc;
  }, {});

  if (loading) {
    return (
      <>
        {/* <Preheader /> */}
        <Superheader />
        <div className={isSticky ? "header-wrapper sticky" : "header-wrapper"}>
          <Header />
        </div>
        <Headerads />
        <div className="loading-spinner">
          <ProgressLoader />
        </div>
      </>
    );
  }

  return (
    <>
      {/* <Preheader /> */}
      <Superheader />
      <div className={isSticky ? "header-wrapper sticky" : "header-wrapper"}>
        <Header />
      </div>
      <Headerads />

      {/* Home Category Content */}
      <div className="home-category-container">
        {/* Featured Subcategories */}
        {Object.entries(productsBySubCategory).map(
          ([subCategoryId, { name, products }]) => (
            <div key={subCategoryId} className="home-subcategory-section">
              <div className="subcategory-header">
                <h2 className="home-subcategory-title">{name}</h2>
                <button
                  className="see-all-btn"
                  onClick={() => handleSeeAllClick(subCategoryId, name)}
                >
                  See All
                </button>
              </div>
              <div className="home-products-scroll-container">
                <div className="home-products-scroll">
                  {products.map((product) => (
                    <div key={product.id} className="home-product-card">
                      <div
                        className="product-image-container"
                        onClick={() => handleProductClick(product)}
                      >
                        <img
                          src={
                            product.productImage
                              ? `https://api.dremerz.net/uploads/${product.productImage}`
                              : "/default-product.jpg"
                          }
                          alt={product.brandName}
                          className="product-image"
                        />
                        {product.tags && (
                          <span className="product-tag">{product.tags}</span>
                        )}
                      </div>
                      <div className="product-info">
                        <h3 onClick={() => handleProductClick(product)}>
                          {product.brandName}
                        </h3>
                        <p className="home-product-name m-0">{product.productName}</p>
                        <div className="home-product-price">
                          <span className="home-current-price">
                            ₹{product.sellingPrice}
                          </span>

                          {product.originalPrice && (
                            <>
                              <span className="home-original-price">
                                ₹{product.originalPrice}
                              </span>
                              <span className="home-offer">
                                 {" "}({Math.round(
                                  ((product.originalPrice -
                                    product.sellingPrice) /
                                    product.originalPrice) *
                                    100
                                )}
                                % OFF)
                              </span>
                            </>
                          )}
                        </div>

                        <div className="home-product-actions">
                          <button
                            className={`home-action-btn home-wishlist-btn ${
                              wishlistStatus[product.id]
                                ? "home-in-wishlist"
                                : ""
                            }`}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleWishlistToggle(product.id);
                            }}
                          >
                            {wishlistStatus[product.id] ? (
                              <FaHeart />
                            ) : (
                              <FaRegHeart />
                            )}

                            {wishlistStatus[product.id]
                              ? " Wishlisted"
                              : " Wishlist"}
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )
        )}
      </div>

      <Prefooterads />
      <Newsletter />
      <Footer />
      <SocialLinks />
      <Endfooter />

      {/* Login Alert Modal */}
      {showLoginAlert && (
        <div className="home-modal-overlay">
          <div className="home-modal-content">
            <h3>Login Required</h3>
            <p>Please login to add items to your cart or wishlist.</p>
            <div className="home-modal-actions">
              <button
                className="btn-cancel"
                onClick={() => setShowLoginAlert(false)}
              >
                Cancel
              </button>
              <button className="btn-login" onClick={() => navigate("/login")}>
                Login
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Kalmainhome;
